let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("elJhQ")).then(() => parcelRequire('kSspz'));